import { render, staticRenderFns } from "./TrademarkGrid.vue?vue&type=template&id=64715b0b&scoped=true"
import script from "./TrademarkGrid.vue?vue&type=script&lang=js"
export * from "./TrademarkGrid.vue?vue&type=script&lang=js"
import style0 from "./TrademarkGrid.vue?vue&type=style&index=0&id=64715b0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64715b0b",
  null
  
)

export default component.exports